import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AppliedFilter, RangeFilter } from '@shared/components/filters/Domain/filter.model';
import { rangeValidator } from '@shared/validators/forms/validateRangeKeyForm';
import { PRIMENGModule } from '@shared/prime-ng/prime-ng.module';
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-range-filter',
  standalone: true,
  templateUrl: './range-filter.component.html',
  styleUrl: './range-filter.component.scss',
  imports: [PRIMENGModule, NgIf, ReactiveFormsModule, TranslateModule],
})
export class RangeFilterComponent implements OnInit {
  @Input() filter!: AppliedFilter;
  @Output() filterChange = new EventEmitter<AppliedFilter>();

  rangeForm!: FormGroup;
  rangeFilter!: RangeFilter;

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.transformToRangeFilter();

    this.rangeForm = this.fb.group(
      {
        min: [this.filter?.value ? this.filter?.value.min ?? 1 : 1, [Validators.required]],
        max: [this.filter?.value ? this.filter?.value.max ?? 10000 : 10000, [Validators.required]],
      },
      { validators: rangeValidator },
    );

    this.rangeForm.valueChanges.subscribe(() => {
      this.emitUpdatedFilter();
    });
  }

  private transformToRangeFilter() {
    if (this.filter) {
      this.rangeFilter = this.filter.filter as RangeFilter;
    } else {
      console.error('Invalid filter type, expected RangeFilter');
    }
  }

  emitUpdatedFilter() {
    const { min, max } = this.rangeForm.value;

    const appliedFilter: AppliedFilter = {
      ...this.filter,
      isApplied: min !== max,
      value: { min, max },
    };

    this.filterChange.emit(appliedFilter);
  }
}
